import { render } from "./Quests.vue?vue&type=template&id=47dbbe26"
import script from "./Quests.vue?vue&type=script&lang=js"
export * from "./Quests.vue?vue&type=script&lang=js"

import "./Quests.vue?vue&type=style&index=0&id=47dbbe26&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__